import React, {useState, useContext} from 'react';
import { useSubmit, ToastContext, useAsync, AccountContext } from '../../hooks';
import {ImgTick} from '../../pictures/controls/SVG';
import Input from '../controls/Input';
import Button from '../controls/Button';
import Btn from '../controls/Btn';
import ModalHeading from '../modal/ModalHeading';
import Toast from '../modal/Toast';
import Username from '../user/Username';

import axios from 'axios';

let validateWord = title => {
    if (title.length == 0) return 'Please provide a word!';
    if (title.length < 5) return 'Word too short!';
    if (title.length > 50) return 'Word too long!';
}

function getParticipants(poo) {
    let pool = poo.slice();
    let participants = [];
    for (let n = 0; n < 2; n++) {
        let l = pool.length / 4;
        let i = pool.length-1-Math.floor(Math.random() * l);
        participants.push(pool[i]);
        pool.splice(i, 1);
    }
    return participants;
}

function Pool({ pool: poo, participants, setParticipants }) {
    let pool = poo.slice().reverse();
    console.log({ participants })
    let selected = username => participants && participants.indexOf(username) >= 0
    return <div className="poolSelect">
        {pool.map((username, i) => <Btn className={`participant ${selected(username)?'selected':''}`} key={username} disabled={participants && (participants.length == 2 ? !selected(username) : false)} onClick={() => {
            if (selected(username)) {
                setParticipants(participants.filter(p => p != username));
            } else {
                setParticipants([...participants, username])
            }
        }}>
            <ImgTick className={`tick ${participants && selected(username) ? "ticked" : ''}`} />
            {username}
        </Btn>)}
    </div>
}

export default function StartDuel({ close, callback }) {
    let Toasts = useContext(ToastContext);
    let { user } = useContext(AccountContext);

    let [c, submit, onSubmit] = useSubmit();
    let [loading, setLoading] = useState(false);

    let [pool, setPool] = useState();
    let [participants, setParticipants] = useState();

    let [word, setWord] = useState('');

    let [wordError, setWordError] = useState('');
    let [messageError, setMessageError] = useState('');

    let [serverError, setServerError] = useState('');

    useAsync(async () => {
        let { data } = await axios.post('/api/duel-pool', { user });
        setPool(data);
        setParticipants(getParticipants(data));
    }, [])

    onSubmit(async () => {
        if (!wordError && !messageError) {
            setLoading(true);
            let post = {word, pool, participants:participants.map(p=>({username:p}))};
            let res = await callback(post);
            if (res) {
                close();
                Toasts.create(Toast, { text:'A new duel has been started!' });
            } else {
                Toasts.create(Toast, { type: "error", preset: 'server error' });
                setServerError('Server error!');
            }
            setLoading(false);
        }
    })

    return <div className="StartDuel modal">
        <ModalHeading title="Start a duel!" close={close} />
        {!pool?null:<div className="body">
            <form onSubmit={submit}>

                <Input
                    label="Word"
                    value={word}
                    setValue={setWord}
                    error={wordError}
                    setError={setWordError}
                    validation={validateWord}
                    attempts={c}
                    disabled={loading}
                />
                
                <Pool pool={pool} participants={participants} setParticipants={setParticipants} />

                <br />

                <div className="formButtons">
                    <div className="buttons">
                        <Button disabled={participants && participants.length != 2} submit loading={loading}>Submit</Button>
                    </div>
                    <div className="error">
                        {serverError}
                    </div>
                </div>
            </form>
        </div>}
    </div>
}